import { makeStylesV5 } from '../index';
export default makeStylesV5()(() => ({
    AddressFormContainer: {
        maxWidth: '600px'
    },
    ShortField: {
        width: '40%',
        minWidth: '200px',
        fieldset: { legend: { maxWidth: '100%' } }
    },
    AutocompleteDropdownContainer: {
        alignItems: 'center',
        '& > div': {
            width: '100%',
            wordWrap: 'break-word'
        }
    },
    AutocompleteDropdownSecondaryText: {
        display: 'block'
    }
}));
//# sourceMappingURL=styles.js.map